import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import MainPage from '../Pages/MainPage';
import TabMode from '../Enums/TabMode';

function MainPageRouter(): JSX.Element {
  
    return (
        <BrowserRouter>
            <Routes>
                <Route path='/' element={<MainPage tabMode={TabMode.ITEMS} subView={null} />} />
                <Route path='/items' element={<MainPage tabMode={TabMode.ITEMS} subView={null} />} />
                <Route path='/items/:itemId' element={<MainPage tabMode={TabMode.ITEMS} subView={null} />} /> {/*would be better if the itemId could be sent as a prop directly, but don't think that is possible*/}
                <Route path='/documents' element={<MainPage tabMode={TabMode.DOCUMENTS} subView={null} />} />
                <Route path='/documents/:treeNodeId' element={<MainPage tabMode={TabMode.DOCUMENTS} subView={null} />} /> {/*would be better if the treeNodeId could be sent as a prop directly, but don't think that is possible*/}
                <Route path='/settings' element={<MainPage tabMode={TabMode.SETTINGS} subView={null} />} />
                <Route path='/settings/pin' element={<MainPage tabMode={TabMode.SETTINGS} subView='pin' />} />
                <Route path='/settings/about' element={<MainPage tabMode={TabMode.SETTINGS} subView='about' />} />
                <Route path='*' element={<MainPage tabMode={TabMode.ITEMS} subView={null} />} />
            </Routes>
        </BrowserRouter>
    );
}

export default MainPageRouter;